import Vue from 'vue'
import numeral from 'numeral';
import 'numeral/locales/fr';

Vue.filter("toUppercase", function (value) {
	if(!value) {
		return
	}
	return value.toUpperCase();
});

Vue.filter("toLowercase", function (value) {
	if(!value) {
		return
	}
	return value.toLowerCase();
});

Vue.filter("capitalize", function (value) {
	if (!value && value !== 0) return;
	return value.replace(/\b\w/g, l => l.toUpperCase());
});

Vue.filter("formatNumber", function (value, format) {
	if(!value) {
		return
	}
	if (format === '0 0') {
		return numeral(value).format('0,0').replace(/,/g, ' ')
	}
	return numeral(value).format(format);
});

Vue.filter("randomizeNumber", function (value, min, max) {
	if(!value) {
		return
	}
	return Math.floor(Math.random() * max) + min
});

Vue.filter('stripHTML', function (value) {
	if(!value) {
		return
	}
	return value.replace(/<(?:.|\n)*?>/gm, '');
});

Vue.filter('truncate', function (text, length, clamp) {
	text = text || '';
	clamp = clamp || '...';
	length = length || 50;
	if (text.length <= length) return text;
	var tcText = text.slice(0, length - clamp.length);
	var last = tcText.length - 1;
	while (last > 0 && tcText[last] !== ' ' && tcText[last] !== clamp[0]) last -= 1;
	last = last || length - clamp.length;
	tcText =  tcText.slice(0, last);
	return tcText + clamp;
});

Vue.filter("formatCurrency", function (value, currency) {
	if(!value || value == 0) {
		return "-"
	}
	numeral.locale('en');
	return currency+" "+numeral(value).format('0,0.00');
});

Vue.filter('initials', function (value) {
	if(!value) {
		return
	}
	var initials = value.match(/\b\w/g) || [];
	return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
});

Vue.filter('json', function (value) {
	if(!value) {
		return
	}
	return JSON.stringify(value, null, 2);
});

Vue.filter('hashCCnumber', function (value) {
	if(!value) {
		return
	}
	return value.replace(/[^0-9]+/g, '').replace(/[0-9](?=([0-9]{4}))/g, '*');
});

// Date formats:
import moment from 'moment'

Vue.filter('formatDate', function (value) {
	if (value) {
		return moment(String(value)).format('DD.MM.YYYY');
	}
});

Vue.filter('formatDateTime', function (value) {
	if (value) {
		return moment(String(value)).format('DD.MM.YYYY HH:mm');
	}
});

Vue.filter('formatDateRange', function (start, end) {
	if (start && end) {
		let s = moment(start);
		let e = moment(end);
		if (s.month() == e.month()){
			return s.format('MMM DD')+" - "+e.format('DD, YYYY');
		}
		return s.format('MMM DD')+" - "+e.format('MMM DD, YYYY');
	}
	return "No dates available.";
});
Vue.filter( 'flagClass', function (value) {
	if(!value){
		return '';
	}
	return 'flag-'+value.toLowerCase();
});
Vue.filter('formatAddress', function(order) {

	let addr = (order.company ? order.company+"<br />":"");
	addr += (order.gender ? order.gender === "HERR" ? "Herrn " : order.gender === "FRAU"? "Frau ": "":"")+(order.firstname ? order.firstname+" ":"")+(order.name ? order.name+" ":"")+"<br />";
	addr += (order.address ? order.address+"<br />":"");
	addr += (order.address2 ? order.address2+"<br />":"");
	addr += (order.zip ? order.zip+" ":"")+(order.city ? order.city+" ":"");

	return addr;
});

Vue.filter( 'formatGender', function(gender){
	if(gender === "HERR"){
		return "Herrn"
	}
	if(gender === "FRAU"){
		return "Frau"
	}
	return "";
});